import { useRouter } from 'next/router'
import React, { useEffect, useState } from 'react'
import { api } from '../../../utils'
import LoadingSvg from '../../atoms/Loading/Loading'
import OrdineRiepilogoCard from '../../molecules/OrdineRiepilogoCard/OrdineRiepilogoCard'
import FormCheckout from '../../organisms/FormCheckout/FormCheckout'
import Button from '../../atoms/Button/Button'
import { ChevronLeft } from '../../atoms/NewIcons'
import useTrans from '../../../hooks/useTrans'
import CheckoutAlerts from '../../organisms/CheckoutAlerts/CheckoutAlerts'
import OrdineRiepilogoCardCarrello from '../../molecules/OrdineRiepilogoCardCarrello/OrdineRiepilogoCardCarrello'
import NewModal from '../../molecules/NewModal/NewModal'
import * as Sentry from '@sentry/browser'

const CheckoutTemplate = ({ service_gift, carrello_main }) => {
  const [isReady, setIsReady] = useState()
  const [isSubmit, setIsSubmit] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [checkDisponibilitaError, SetCheckDisponibilitaError] = useState(false)
  let router = useRouter()
  const t = useTrans()

  const isPromoValida = isReady
    ? isReady?.promozioni_applicate?.length > 0 ||
      isReady?.righe_carrello?.some((riga) => riga.promozioni_applicate?.length > 0)
    : true

  const ConfermaOrdine = () => {
    setIsSubmitting(true)
    isReady &&
      api
        .get(`ordini/${isReady.id}/url_pagamento`, {
          params: {
            lang: router.locale,
          },
        })
        .then((res) => {
          router.push(res.data)
        })
        .catch((err) => {
          setIsSubmitting(false)

          if (err.response.data && err.response.data.error) {
            if (err.response.data.error === 'check_disponibilita_failure') {
              SetCheckDisponibilitaError(true)
            }
          }

          Sentry.captureException(err)
        })
  }

  return (
    <div className="w-container">
      <div className="checkout">
        {carrello_main?.step && carrello_main?.step_name && (
          <h2 style={{ textAlign: 'center' }}>
            <strong>
              {' '}
              Checkout {carrello_main?.step}{' '}
              {carrello_main?.steps_count && `di ${carrello_main?.steps_count}`}
              {': '}
            </strong>{' '}
            {carrello_main?.step_label}
          </h2>
        )}
        <Button
          href="/cart"
          label={t('Torna al Carrello')}
          variant="ghost"
          size="medium"
          icon={<ChevronLeft />}
          icon_pos="left"
          className="checkout__link"
        />
        <CheckoutAlerts errori={carrello_main?.errori} />

        <div className="checkout__content">
          <div className="checkout__main">
            {carrello_main === undefined ? (
              <LoadingSvg />
            ) : (
              <FormCheckout
                setIsSubmit={setIsSubmit}
                carrello_main={carrello_main}
                pushPayload={setIsReady}
                service_gift={service_gift}
                promoCodeErrorMessage={isReady?.promo_code_error}
                promoCodeAlertMessage={isReady?.promo_code_alert}
              />
            )}
          </div>

          {/* 
            Condizione Momentanea da cambiare una volta che si renderà la struttura del Cart Uguale
            Attualmente dentro OrdineRiepilogoCard se cliccato Personalizzazione non si vede
            è dovuto alla struttura del Cart Diversa.
          */}
          <div className="checkout__sidebar">
            {isReady ? (
              <OrdineRiepilogoCard
                isLoading={isSubmit}
                isCheckout={true}
                isSubmitting={isSubmitting}
                ConfermaOrdine={ConfermaOrdine}
                consegnaPrevista={
                  isReady?.data_consegna_prevista ? isReady?.data_consegna_prevista : null
                }
                isReady={isReady}
                ordine={isReady ? isReady : carrello_main}
                carrelloCheckout={carrello_main}
                isPromoValida={isPromoValida}
              />
            ) : (
              <OrdineRiepilogoCardCarrello
                isLoading={isSubmit}
                isCheckout={true}
                ConfermaOrdine={ConfermaOrdine}
                consegnaPrevista={
                  isReady?.data_consegna_prevista ? isReady?.data_consegna_prevista : null
                }
                isReady={isReady}
                ordine={isReady ? isReady : carrello_main}
              />
            )}
          </div>

          <NewModal
            visible={checkDisponibilitaError}
            alert={true}
            title={t('La quantita di uno o più articoli richiesti non è più disponibile.')}
            actions={[
              <Button
                variant="primary"
                label={t('Torna al carrello')}
                onClick={() => router.push('/cart')}
              />,
            ]}
          />
        </div>
      </div>
    </div>
  )
}

export default CheckoutTemplate
